module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 100
    }
  }, [(_vm.isError) ? _c('Infotext', {
    attrs: {
      "text": _vm.errorMessage
    }
  }, [_c('Button', {
    attrs: {
      "bordered": true,
      "autowidth": true
    },
    on: {
      "click": _vm.closeMessages
    }
  }, [_vm._v("Закрыть")])], 1) : [(_vm.isHasTeams) ? _c('MentoringTeamsList', {
    attrs: {
      "items": _vm.teams,
      "child": _vm.currentChild
    }
  }) : _c('MentoringEmptyTeams', {
    on: {
      "addRequest": _vm.addRequest
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28fbf77d","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/views/teams/MentoringTeams.vue
// module id = ba2877deedfb7857468e
// module chunks = 66